export const INVITE_STATUS_NOT_INVITED = 'not_invited';
export const INVITE_STATUS_INVITED = 'invited';
export const INVITE_STATUS_JOINED = 'joined';

export const inviteStatuses = [
  INVITE_STATUS_NOT_INVITED,
  INVITE_STATUS_INVITED,
  INVITE_STATUS_JOINED,
] as const;

export type InviteStatus = (typeof inviteStatuses)[number];
